module.exports = __webpack_public_path__ + "13a5aa51f8ca10b7738c3c210ab0f665.svg";